module.exports = __webpack_public_path__ + "img/xz2compact.62db0b0d.jpg";